// import React from "react";
import React, {useState, useEffect} from "react";
import {Form} from "./Elements/appUtils";
import {useDispatch} from "react-redux";

import {GetEachFormFields} from "./_utils/formUtils";
import {
    addPosCustomerFxn,verifyGstinFxn,fetchPosCustomer
} from "../containers/customer/action";
import {notification} from "./Elements/appUtils";

const AddCustomerComponent = (props) => {
    let {onSubmit} = props;
    let dispatch = useDispatch();
    const [customerSearch, setCustomerSearch] = useState("");
    const [customerList, setCustomerList] = useState([]);
    const [gstVerifiedData, setGstVerifiedData] = useState({});
    const handleSelectCustomer = (customer) => {
        props.form.setFieldsValue({
            name: customer.name || "",
            mobileNo: customer.mobileNo || "",
            email: customer.email || "",
            gstIn: customer.gstIn || "",
            address: customer.address || "",
        });

        setCustomerSearch(`${customer.name || ""} ${customer.mobileNo ? `(${customer.mobileNo})` : ""}`);
        setCustomerList([]);
    };

    useEffect(() => {
        if (props.selectedCustomer) {
            handleSelectCustomer(props.selectedCustomer);

        }
    }, [props.selectedCustomer]);
    const handleVerifyGst = async () => {
        const gstIn = props.form.getFieldValue("gstIn");

        if (!gstIn) {
            notification.warning({ message: "Please enter GST number" });
            return;
        }

        let resp = await verifyGstinFxn({ gstNumber: gstIn });

        if (resp && !resp.error) {
            notification.success({ message: resp.message || "GST verified" });

            const data = resp.data || {};
            setGstVerifiedData({
                tradeName: data.tradeName || "",
                legalName: data.legalName || "",
                address: data.address || "",
                address1: data.address1 || "",
                address2: data.address2 || "",
                pinCode: data.pinCode || "",
                state: data.state || "",
                stateCode: data.stateCode || "",
                city: data.city || "",
                cityName: data.cityName || "",
                registrationType: data.registrationType || "",
                businessType: data.businessType || "",
                gstStatus: data.status || data.gstStatus || "",
                gstVerified: true,
                gstVerifiedAt: new Date(),
            });
            const fullAddress = [data.address || "", data.pinCode || ""].filter(part => part && part.trim() !== "").join(", ");
            props.form.setFieldsValue({
                name: data.name || "",
                gstIn: data.gstin || gstIn,
                email: data.email || props.form.getFieldValue("email") || "",
                mobileNo: data.mobileNo || props.form.getFieldValue("mobileNo") || "",
                address: fullAddress,
            });
        } else {
            setGstVerifiedData({});
            notification.error({ message: resp.message || "Invalid GST number" });
        }
    };
    const handleCustomerSearch = async (value) => {
        setCustomerSearch(value);

        if (!value || value.length < 2) {
            setCustomerList([]);
            return;
        }

        let resp = await fetchPosCustomer({
            name: value,
            mobileNo: value,
            regExFilters: ["name", "mobileNo"]
        });

        if (resp && resp.data) {
            setCustomerList(resp.data);
        } else {
            setCustomerList([]);
        }
    };
    const handleSubmit = (e) => {
        const {form} = props;
        e.preventDefault();

        form.validateFields(async (err, valData) => {
            if (!err) {
                if (!valData.name) {
                    notification.warning({message: "Please Enter Name"});
                    return;
                }

                // if (!valData.mobileNo) {
                //     notification.warning({message: "Please Enter Mobile Number"});
                //     return;
                // }
                // if (!gstVerifiedData.gstVerified && !valData.mobileNo) {
                //     notification.warning({ message: "Please Enter Mobile Number" });
                //     return;
                // }

                let x = await dispatch(addPosCustomerFxn({
                    ...valData,
                    ...gstVerifiedData,
                }));

                if (x && x.success) {
                    if (onSubmit) {
                        onSubmit(x.addCustomer);
                    }

                    props.form.setFieldsValue({
                        name: "",
                        mobileNo: "",
                        email: "",
                        gstIn: "",
                        address: "",
                    });

                    setGstVerifiedData({});
                }
            }
        });
    };
    let inputTypes = {
        fields: [
            {
                key: "name",
                label: "Name *",
                span: "col-md-6",
                placeholder: "Name",
            },
            {
                key: "email",
                label: "Email ",
                span: "col-md-6",
                placeholder: "Enter Email",
                type: "email",
            },
            {
                key: "mobileNo",
                label: "Mobile No",
                span: "col-md-6",
                placeholder: "Mobile No",
            },
            {
                key: "gstIn",
                label: "Gst No",
                span: "col-md-6",
                placeholder: "Gst",
            },
            {
                key: "address",
                label: "Address",
                span: "col-md-12",
                placeholder: "Address",
                type: "textarea",
            },
        ],
    };

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <div className="form-elements-wrapper">
                    <div className={"row"}>
                        {/*{inputTypes.fields.map((item, key) => {*/}
                        {/*    return !item.hidden ? (*/}
                        {/*        <div*/}
                        {/*            className={` ${item.span ? item.span : "col-md-6"}`}*/}
                        {/*            key={key}*/}
                        {/*        >*/}
                        {/*            <GetEachFormFields {...props.form} item={item}/>*/}
                        {/*        </div>*/}
                        {/*    ) : null;*/}
                        {/*})}*/}
                        {inputTypes.fields.map((item, key) => {
                            if (item.key === "gstIn") {
                                return (
                                    <div className={`${item.span ? item.span : "col-md-6"}`} key={key}>
                                        <div style={{ position: "relative" }}>

                                            {/* Input */}
                                            <GetEachFormFields
                                                {...props.form}
                                                item={{
                                                    ...item,
                                                    style: { paddingRight: "90px" }
                                                }}
                                            />
                                            {/* Clear (❌) Button */}
                                            {props.form.getFieldValue("gstIn") && (
                                                <span
                                                    onClick={() => {
                                                        props.form.setFieldsValue({ gstIn: "" });
                                                        setGstVerifiedData({});
                                                    }}
                                                    style={{
                                                        position: "absolute",
                                                        top: 31,
                                                        right: 90,
                                                        height: "53%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                        color: "#999"
                                                    }}
                                                >
        ❌
    </span>
                                            )}

                                            {/* Button */}
                                            {/*<button*/}
                                            {/*    type="button"*/}
                                            {/*    className="btn btn-success"*/}
                                            {/*    onClick={handleVerifyGst}*/}
                                            {/*    style={{*/}
                                            {/*        position: "absolute",*/}
                                            {/*        top: 31,*/}
                                            {/*        right: 8,*/}
                                            {/*        height: "53%",*/}
                                            {/*        borderRadius: "0 4px 4px 0",*/}
                                            {/*        padding: "0 16px"*/}
                                            {/*    }}*/}
                                            {/*>*/}
                                            {/*    Verify*/}
                                            {/*</button>*/}
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={handleVerifyGst}
                                                disabled={gstVerifiedData.gstVerified}
                                                style={{
                                                    position: "absolute",
                                                    top: 31,
                                                    right: 8,
                                                    height: "53%",
                                                    borderRadius: "0 4px 4px 0",
                                                    padding: "0 16px",
                                                    opacity: gstVerifiedData.gstVerified ? 0.7 : 1,
                                                    cursor: gstVerifiedData.gstVerified ? "not-allowed" : "pointer"
                                                }}
                                            >
                                                {gstVerifiedData.gstVerified ? "Verified" : "Verify"}
                                            </button>

                                        </div>
                                    </div>
                                );
                            }

                            return !item.hidden ? (
                                <div className={`${item.span ? item.span : "col-md-6"}`} key={key}>
                                    <GetEachFormFields {...props.form} item={item}/>
                                </div>
                            ) : null;
                        })}
                    </div>
                </div>
                <div className="col-md-12 mb-3">
                </div>
                <button type="submit" className="btn btn-primary">
                    Submit
                </button>
                <hr
                    style={{
                        marginBottom: "50px",
                        marginTop: "60px",
                        height: "2px",
                        background: "grey",
                    }}
                />
            </Form>
        </>
    );
};

export default Form.create()(AddCustomerComponent);
